module.exports = __webpack_public_path__ + "static/media/sort-descend.1b025eea.svg";